function Transaction() {
	return (
		<div className='text-blue-700'>Admin Transaction</div>
	)
}

export default Transaction